import React, { useContext } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { LANGUAGES } from "../constants/languages";
import { useTranslation } from "react-i18next";
import {
  CDBSidebar,
  CDBSidebarContent,
  CDBSidebarHeader,
  CDBSidebarMenu,
  CDBSidebarMenuItem,
  CDBSidebarFooter,
} from "cdbreact";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import AuthContext from "../context/AuthProvider";
import Hamburger from 'hamburger-react'

const SideBar = ({ toggleSidebar,isSidebarClosed }) => {
  const { i18n, t } = useTranslation();

  const { setAuth } = useContext(AuthContext);
  const navigate = useNavigate();

  const onChangeLang = (e) => {
    const lang_code = e.target.value;
    i18n.changeLanguage(lang_code);
  };

  const logout = async () => {
    setAuth({});
    navigate('/login');
  }

  return (
    <div
      style={{
        display: "flex",
        height: "100%",
        overflow: "scroll initial",
        position: "fixed",
        top: "0",
        left: "0",
        zIndex: 1020
      }}
    >
      <CDBSidebar textColor="#333" backgroundColor="#f0f0f0" toggled={isSidebarClosed}>
        <CDBSidebarHeader
          prefix={
            <div className={"sidebar-hamburger"}>
              <Hamburger
                toggled={!isSidebarClosed}
                toggle={toggleSidebar}
                size={25}
              />
            </div>
          }>
          <div className={"py-2 my-1"}>
            <NavLink
              exact
              to="/home"
              className="text-decoration-none"
              style={{ color: "inherit" }}
            >{t("menu")}</NavLink>
          </div>
        </CDBSidebarHeader>

        <CDBSidebarContent className="sidebar-content">
          {!isSidebarClosed &&
            <CDBSidebarMenu>
              <NavLink exact to="/home" activeClassName="activeClicked">
                <CDBSidebarMenuItem className={"sidebar-element sidebar-element-hover"}>
                  {t("home")}
                </CDBSidebarMenuItem>
              </NavLink>
              <NavLink exact to="/graves" activeClassName="activeClicked">
                <CDBSidebarMenuItem className={"sidebar-element sidebar-element-hover"}>
                  {t("gravesList")}
                </CDBSidebarMenuItem>
              </NavLink>
              <NavLink exact to="/departed" activeClassName="activeClicked">
                <CDBSidebarMenuItem className={"sidebar-element sidebar-element-hover"}>
                  {t("departedList")}
                </CDBSidebarMenuItem>
              </NavLink>
              <NavLink exact to="/cementerypatheditor" activeClassName="activeClicked">
                <CDBSidebarMenuItem className={"sidebar-element sidebar-element-hover"}>
                  {t("cemPathEditor")}
                </CDBSidebarMenuItem>
              </NavLink>
            </CDBSidebarMenu>
          }
        </CDBSidebarContent>

        <CDBSidebarFooter
          className={"text-center"}
        >
          <div
            style={{
              padding: "20px 5px",
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              fontFamily: "Arial"
            }}
          >
            {isSidebarClosed ?
              <Form.Select
                value={i18n.language}
                onChange={onChangeLang}
                style={{ maxWidth: "150px" }}
                className={"shadow border-0 p-2 px-3 modal-background-color"}
              >
                {LANGUAGES.map(({ code, label, flag }) => (
                  <option key={code} value={code}>
                    {label}
                  </option>
                ))}
              </Form.Select>
              : <>
                <Button
                  variant="outline-dark"
                  onClick={logout}
                  style={{
                    margin: "8px",
                    width: "180px"
                  }}
                  className={"shadow border-0 p-2 px-5"}
                >{t("SignOut")}</Button>
                <Form.Select
                  value={i18n.language}
                  onChange={onChangeLang}
                  style={{ width: "180px" }}
                  className={"shadow border-0 p-2 text-center modal-background-color"}
                >
                  {LANGUAGES.map(({ code, label, flag }) => (
                    <option key={code} value={code}>
                      {flag + " " + label}
                    </option>
                  ))}
                </Form.Select>
              </>
            }
          </div>
        </CDBSidebarFooter>
      </CDBSidebar>
    </div>
  );
};

export default SideBar;
